import React from "react";
import Modal from "react-bootstrap/Modal";
import styles from "./DifficultySelectionModal.module.css";

const DifficultySelectionModal = ({
  showModal,
  setShowModal,
  onDifficultySelect,
}) => {
  const difficulties = [
    { id: "beginner", label: "সহজ (৪x৪)" },
    { id: "intermediate", label: "মধ্যম (৬x৪)" },
    { id: "advanced", label: "কঠিন (৮x৪)" },
  ];

  return (
    <Modal
      show={showModal}
      centered
      dialogClassName={styles.difficultyModalDialog}
      contentClassName={styles.difficultyModalContent}
      onHide={() => setShowModal(false)}
    >
      <Modal.Body className={styles.difficultyModalBody}>
        <button
          className={styles.closeButton}
          onClick={() => setShowModal(false)}
        >
          ✕
        </button>
        <div className={styles.infoContainer}>
          <span className={styles.infoText}>কঠোরতা নির্বাচন করুন</span>
        </div>
        <div className={styles.difficultyContainer}>
          {difficulties.map((difficulty) => (
            <div
              key={difficulty.id}
              className={styles.difficultyItem}
              onClick={() => {
                onDifficultySelect(difficulty.id);
                setShowModal(false);
              }}
            >
              <span>{difficulty.label}</span>
              <span className={styles.arrowText}>→</span>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DifficultySelectionModal;
